import services from 'services/services';
import * as types from '../types';

// Import helpers
import { checkFetchErrors } from '../helpers_actions/convert_helpers';

// ******************** FETCH CSV DATA ********************
export const getCSVData = (url) => async (dispatch) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.GET_CSV_DATA_LOADING,
			payload: true
		});

		const { data } = await services.get(url);

		dispatch({
			type: types.GET_CSV_DATA_SUCCESS,
			payload: data
		});
	} catch (error) {
		dispatch({
			type: types.GET_CSV_DATA_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};

// ******************** CLEAR CSV DATA ********************
export const clearCSVData = () => (dispatch) => {
	return dispatch({
		type: types.CLEAR_CSV_DATA
	});
};
